import state from './backup.state'
import mutations from './backup.mutations'
import actions from './backup.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
